import React from 'react';

const TabelaArmazenagemContext = React.createContext();

export default TabelaArmazenagemContext;
